// extracted by mini-css-extract-plugin
export default {"form":"styles_form__TD4NK","inputWrap":"styles_inputWrap__L-9DN","btn":"styles_btn__25zck","req":"styles_req__6QoYn"};